/**
* @version GENERATOR_VERSION::20200408
* @DateTime 2020-04-10T11:30:43.727
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	saveContractSubjectManage,
	getContractSubjectManageCreateInit,
	getContractSubjectManageEditInit,
	getContractSubjectManageView,
	deleteContractSubjectManage
} from '@api/storagemanage/ContractSubjectManage';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},
	actions: {
		getContractSubjectManageCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getContractSubjectManageCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getContractSubjectManageEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getContractSubjectManageEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveContractSubjectManage({}, ContractSubjectManage) {
			return new Promise((resolve, reject) => {
				saveContractSubjectManage(ContractSubjectManage)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		getContractSubjectManageView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getContractSubjectManageView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		deleteContractSubjectManage({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteContractSubjectManage({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
